<div class="user-roster">
    <header class="user-roster-head">
        <div class="user-roster-copy">
            <h1>Area utenti</h1>
            <p>Anagrafica di società, staff e atleti registrati sulla piattaforma.</p>
        </div>
        <span class="user-roster-count" *ngIf="!loading">{{ totalRecords }} utenti</span>
    </header>

    <form class="user-roster-toolbar" (submit)="$event.preventDefault(); applyFilters()">
        <div class="inline-flex shrink-0 rounded-lg bg-slate-100 p-0.5" role="group" aria-label="Cerca per">
            <button type="button" *ngFor="let mode of searchModes"
                    class="rounded-md border-0 px-3 py-1.5 text-xs font-semibold transition-colors"
                    [ngClass]="searchMode === mode.id ? 'bg-white text-slate-900 shadow-sm' : 'bg-transparent text-slate-500 hover:text-slate-800'"
                    [attr.aria-pressed]="searchMode === mode.id" (click)="setSearchMode(mode.id)">
                {{ mode.label }}
            </button>
        </div>
        <input
            type="search"
            class="form-control form-control-solid"
            [(ngModel)]="textFilter"
            name="userSearch"
            [placeholder]="searchMode === 'athlete' ? 'Cerca nome, cognome o codice fiscale dell\'atleta' : 'Cerca nome, cognome o email'"
            (keyup.enter)="applyFilters()"
        />
        <button
            type="button"
            class="btn welldone-btn-gray user-filter-trigger"
            [class.is-open]="!!activeFilterCount"
            (click)="filtersPanel.toggle($event)"
        >
            <i class="bi bi-funnel" aria-hidden="true"></i>
            Filtri
            <span class="user-filter-badge" *ngIf="activeFilterCount">{{ activeFilterCount }}</span>
        </button>
        <button type="submit" class="btn btn-primary">Cerca</button>
        <button type="button" class="btn btn-reset-link" *ngIf="hasActiveQuery" (click)="resetAll()">Reset</button>
    </form>

    <p-overlayPanel #filtersPanel [dismissable]="false" styleClass="user-filter-popover">
        <div class="user-filter-form">
            <div class="user-filter-field">
                <label class="form-label" for="user-type">Tipologia</label>
                <p-multiSelect
                    inputId="user-type"
                    styleClass="wisper-multiselect"
                    panelStyleClass="wisper-multiselect-panel"
                    [options]="typesOfAccout"
                    [(ngModel)]="selectedTypeIds"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Tutte"
                    display="chip"
                    [filter]="true"
                    filterPlaceHolder="Cerca tipologia"
                    [showToggleAll]="false"
                    [resetFilterOnHide]="true"
                    emptyFilterMessage="Nessun risultato"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                ></p-multiSelect>
            </div>

            <div class="user-filter-field">
                <label class="form-label" for="user-company">Società</label>
                <p-multiSelect
                    inputId="user-company"
                    styleClass="wisper-multiselect"
                    panelStyleClass="wisper-multiselect-panel"
                    [options]="companies"
                    [(ngModel)]="selectedCompanyIds"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Tutte"
                    display="chip"
                    [filter]="true"
                    filterPlaceHolder="Cerca società"
                    [showToggleAll]="true"
                    [resetFilterOnHide]="true"
                    [disabled]="noCompany"
                    emptyFilterMessage="Nessun risultato"
                    selectedItemsLabel="{0} società"
                    [maxSelectedLabels]="2"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                ></p-multiSelect>
            </div>

            <div class="user-filter-field">
                <label class="form-label" for="user-status">Stato</label>
                <p-multiSelect
                    inputId="user-status"
                    styleClass="wisper-multiselect"
                    panelStyleClass="wisper-multiselect-panel"
                    [options]="statusOptions"
                    [(ngModel)]="selectedStatusIds"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Tutti"
                    display="chip"
                    [showToggleAll]="false"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                ></p-multiSelect>
            </div>

            <div class="user-filter-field">
                <label class="form-label" for="user-sort">Ordina per</label>
                <p-dropdown
                    inputId="user-sort"
                    styleClass="wisper-select"
                    panelStyleClass="wisper-select-panel"
                    [options]="sortOptions"
                    [(ngModel)]="sortBy"
                    optionLabel="name"
                    optionValue="id"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                ></p-dropdown>
            </div>

            <label class="user-filter-switch">
                <span>Solo utenti senza società</span>
                <p-inputSwitch [(ngModel)]="noCompany" (ngModelChange)="onNoCompanyChange($event)"></p-inputSwitch>
            </label>

            <div class="user-filter-actions">
                <button type="button" class="btn btn-reset-link" (click)="clearAdvancedFilters()">Azzera</button>
                <button type="button" class="btn btn-primary" (click)="applyFilters()">Applica</button>
            </div>
        </div>
    </p-overlayPanel>

    <p-table
        [value]="users"
        dataKey="id"
        [lazy]="true"
        [paginator]="true"
        [rows]="rows"
        [first]="first"
        [totalRecords]="totalRecords"
        [loading]="loading"
        [rowsPerPageOptions]="[30,50,100]"
        [rowHover]="true"
        responsiveLayout="scroll"
        styleClass="user-roster-table"
        paginatorDropdownAppendTo="body"
        currentPageReportTemplate="{first}–{last} di {totalRecords}"
        [showCurrentPageReport]="true"
        (onLazyLoad)="loadUsers($event)"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Utente</th>
                <th>Società</th>
                <th>Tipologia utente</th>
                <th>Stato</th>
                <th class="user-col-actions">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr class="user-roster-row" (click)="openUser(row)">
                <td>
                    <div class="user-identity">
                        <app-identity-avatar
                            [imageUrl]="row.image"
                            [initials]="initials(row)"
                            [colorKey]="row.id || row.email || (row.firstName + row.lastName)"
                        ></app-identity-avatar>
                        <div class="user-identity-text">
                            <span class="user-name">{{ row.firstName }} {{ row.lastName }}</span>
                            <span class="user-email">{{ row.email }}</span>
                            <span *ngIf="row.athletes?.length" class="mt-0.5 flex min-w-0 items-center gap-1 text-xs text-slate-500">
                                <i class="bi bi-person-badge shrink-0" aria-hidden="true"></i>
                                <span class="truncate">{{ athleteNames(row) }}</span>
                            </span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="user-company" *ngIf="row.company?.name; else noCompany">
                        <i class="bi bi-building" aria-hidden="true"></i>
                        <span>{{ row.company?.name }}</span>
                    </div>
                    <ng-template #noCompany>
                        <span class="user-muted">—</span>
                    </ng-template>
                </td>
                <td>
                    <span class="badge badge-unknown user-icon-badge">
                        <i class="bi" [ngClass]="accountTypeIcon(row.userGroupId)" aria-hidden="true"></i>
                        {{ accountTypeLabel(row.userGroupId) }}
                    </span>
                </td>
                <td>
                    <span class="badge user-icon-badge" [ngClass]="statusBadgeClass(row.status)">
                        <i class="bi" [ngClass]="statusIcon(row.status)" aria-hidden="true"></i>
                        {{ statusLabel(row.status) }}
                    </span>
                </td>
                <td class="user-col-actions" (click)="$event.stopPropagation()">
                    <div class="user-actions">
                        <button
                            type="button"
                            class="btn welldone-btn-gray"
                            title="Dettagli"
                            (click)="openUser(row)"
                        >
                            <i class="bi bi-eye" aria-hidden="true"></i>
                        </button>
                        <button
                            *ngIf="row.status === 'active'"
                            type="button"
                            class="btn welldone-btn-gray"
                            title="Accedi come utente"
                            (click)="loginAs(row.email, row.id)"
                        >
                            <i class="bi bi-box-arrow-in-right" aria-hidden="true"></i>
                        </button>
                        <button
                            *ngIf="row.status !== 'active'"
                            type="button"
                            class="btn welldone-btn-danger"
                            title="Elimina"
                            (click)="deleteUser(row.id)"
                        >
                            <i class="bi bi-trash" aria-hidden="true"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
            <tr *ngFor="let row of skeletonRows">
                <td>
                    <div class="user-identity">
                        <div class="user-skel user-skel-mark"></div>
                        <div class="user-identity-text">
                            <div class="user-skel user-skel-title"></div>
                            <div class="user-skel user-skel-line"></div>
                        </div>
                    </div>
                </td>
                <td><div class="user-skel user-skel-company"></div></td>
                <td><div class="user-skel user-skel-chip"></div></td>
                <td><div class="user-skel user-skel-chip"></div></td>
                <td class="user-col-actions">
                    <div class="user-actions">
                        <div class="user-skel user-skel-btn"></div>
                        <div class="user-skel user-skel-btn"></div>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="user-empty">Nessun utente trovato. Prova a cambiare ricerca o filtri.</td>
            </tr>
        </ng-template>
    </p-table>
</div>
